import classes from './Messages.module.scss';

export const INPUT_TAG = {
  OPEN: `<span class="${classes.inputTag}">`,
  CLOSE: '</span>',
}

export const CURRENT_INPUT_TAG = {
    OPEN: `<span class="${classes.inputTag}" data-current="true">`,
    CLOSE: '</span>',
  }

export const  MESSAGE_TAG = {
  OPEN: '[link]',
  CLOSE: '[/link]',
}

export const USER_INPUT_TAG = {
  OPEN: `<span class="${classes.userInputTag}" data-type="user">`,
  CLOSE: '</span>',
}

export const CURRENT_USER_INPUT_TAG = {
  OPEN: `<span class="${classes.userInputTag}" data-current="true" data-type="user">`,
  CLOSE: '</span>',
}

export const USER_MESSAGE_TAG = {
  OPEN: '[user:',
  CLOSE: '[/user]',
}
